import {Link, useMatch} from '@nlabs/gothamjs/router';

import type {ReactElement, ReactNode} from 'react';

interface PublicNavLinkProps {
  readonly activeClassName?: string;
  readonly children: ReactNode;
  readonly className?: string;
  readonly to: string;
}

export const PublicNavLink = ({
  activeClassName = 'text-violet-200 underline decoration-violet-400 decoration-2 underline-offset-8',
  children,
  className = 'transition hover:text-sky-200 focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-violet-300',
  to
}: PublicNavLinkProps): ReactElement => {
  const active = Boolean(useMatch({end: true, path: to}));
  return <Link aria-current={active ? 'page' : undefined} className={`${className} ${active ? activeClassName : 'text-white/65'}`} to={to}>{children}</Link>;
};
